import type { ReportBundle } from '../../../shared/types.js';
import { GapReport } from './GapReport.js';
import { MatrixView } from './MatrixView.js';
import { OnePager } from './OnePager.js';

export function PrintView({ report }: { report: ReportBundle }) {
  return (
    <div className="print-only print-doc">
      <h1>Rung — Levelling case</h1>
      <section>
        <h2>HR one-pager</h2>
        <OnePager report={report} />
      </section>
      <section>
        <h2>Gap report</h2>
        <GapReport report={report} />
      </section>
      <section>
        <h2>Matrix</h2>
        <MatrixView report={report} />
      </section>
    </div>
  );
}
